import React from 'react';

import {
  Image,
  WysiwygField,
} from '@uncinc/uncinc-react-kitchen-sink';

import './style.scss';
import { CoreLink } from '@uncinc/react-drupal-core';

const TaxonomyPartnerTeaser = ({ entity, className }) => {
  const title = entity.getIn(['name', 0, 'value'], '');
  const text = entity.getIn(['field_body', 0, 'processed']);
  const image = entity.getIn(['field_image', 0, 'styles', 'image']);
  const linkUrl = entity.getIn(['field_link', 0, 'alias'], entity.getIn(['field_link', 0, 'uri']));
  const linkTitle = entity.getIn(['field_link', 0, 'title']);

  return (
    <div className="TaxonomyPartnerTeaser">

      <div className="row">
        <div className="TaxonomyPartnerTeaser__name col-12 col-md-8">
          <h3>
            {title}
          </h3>
        </div>
        <div className="col-12 col-md-4">
          <div className="TaxonomyPartnerTeaser__image">
            <Image
              src={image}
              lazyload
              includeWebP
            />
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <div className="TaxonomyPartnerTeaser__body">
            <WysiwygField
              property="schema:text"
              html={text}
            />
          </div>
          {linkUrl && (
            <div className="TaxonomyPartnerTeaser__link">
              <CoreLink className="" to={linkUrl}>
                {linkTitle || 'Ga naar partner'} <i className="icon icon-arrow-right" />
              </CoreLink>
            </div>
          )}
        </div>
      </div>
      <hr />
    </div>
  );
};

export default TaxonomyPartnerTeaser;
